import { createContext, useContext } from "react";

import type { SearchMenuViewModel } from "./types-search-menu";

export const SearchMenuContext = createContext<SearchMenuViewModel | null>(null);

export function useSearchMenuContext(): SearchMenuViewModel {
  const context = useContext(SearchMenuContext);
  if (!context) throw new Error("SearchMenu.* deve ser usado dentro de SearchMenu.Root");
  return context;
}
